import { Box, Button, Text } from '@bonanza-social/moonlight';
import { memo } from 'react';
import { ShopItemInfoProps } from './ShopItemInfo.types';

function ShopItemInfo({ text, close }: ShopItemInfoProps) {
  return (
    <Box alignItems="center" gap="space-600" paddingTop="space-600">
      <Text variant="body-m" color="darkSurfacePrimary">
        {text}
      </Text>
      <Button
        width="100%"
        variant="primary"
        locNS="shop"
        locKey="shopInfoCta"
        onPress={close}
      />
    </Box>
  );
}

export default memo(ShopItemInfo);
